// Faz BO (2026-05-10) — Sidebar menü tanımı (gruplandırılmış + role-bazlı)
// UI/UX brief §4.7 sınıflandırmasına göre.
import React, { useEffect, useMemo, useState } from "react";
import DashboardIcon from "@mui/icons-material/Dashboard";
import BarChartIcon from "@mui/icons-material/BarChart";
import NotificationImportantIcon from "@mui/icons-material/NotificationImportant";
import StickyNote2Icon from "@mui/icons-material/StickyNote2";
import PhoneAndroidIcon from "@mui/icons-material/PhoneAndroid";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import RepeatIcon from "@mui/icons-material/Repeat";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import AssignmentReturnIcon from "@mui/icons-material/AssignmentReturn";
import InventoryIcon from "@mui/icons-material/Inventory";
import ScreenSearchDesktopIcon from "@mui/icons-material/ScreenSearchDesktop";
import CategoryIcon from "@mui/icons-material/Category";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import BuildIcon from "@mui/icons-material/Build";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import PeopleIcon from "@mui/icons-material/People";
import NotificationsIcon from "@mui/icons-material/Notifications";
import GroupsIcon from "@mui/icons-material/Groups";
import GridViewIcon from "@mui/icons-material/GridView";
import RouteIcon from "@mui/icons-material/Route";
import RateReviewIcon from "@mui/icons-material/RateReview";
import StarIcon from "@mui/icons-material/Star";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import EmailIcon from "@mui/icons-material/Email";
import MarkEmailReadIcon from "@mui/icons-material/MarkEmailRead";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import CampaignIcon from "@mui/icons-material/Campaign";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import RemoveShoppingCartIcon from "@mui/icons-material/RemoveShoppingCart";
import WavingHandIcon from "@mui/icons-material/WavingHand";
import LightbulbIcon from "@mui/icons-material/Lightbulb";
import ConnectingAirportsIcon from "@mui/icons-material/ConnectingAirports";
import FilterListIcon from "@mui/icons-material/FilterList";
import CalendarViewWeekIcon from "@mui/icons-material/CalendarViewWeek";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import PublicIcon from "@mui/icons-material/Public";
import MapIcon from "@mui/icons-material/Map";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import SettingsInputComponentIcon from "@mui/icons-material/SettingsInputComponent";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import HistoryIcon from "@mui/icons-material/History";
import HealthAndSafetyIcon from "@mui/icons-material/HealthAndSafety";
import SettingsIcon from "@mui/icons-material/Settings";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";

import { getUserPermissions, canAccessPath } from "../utils/auth";
import { getUsers } from "../services/api";

// Section sırası UI'da bu sırayla render edilir.
// Her item: { label, path, icon, badgeKey?: 'pending' }
function buildMenuDefinition() {
  return [
    {
      section: "Genel",
      items: [
        { label: "Cockpit",          path: "/cockpit",       icon: <PhoneAndroidIcon /> },
        { label: "Dashboard",        path: "/dashboard",     icon: <DashboardIcon /> },
        { label: "Yönetim Merkezi",  path: "/dashboard-v2",  icon: <BarChartIcon /> },
        { label: "Action Center",    path: "/action-center", icon: <NotificationImportantIcon /> },
        { label: "Notlarım",         path: "/notes",         icon: <StickyNote2Icon /> },
      ],
    },
    {
      section: "Satış",
      items: [
        { label: "Siparişler",        path: "/orders",        icon: <ShoppingCartIcon /> },
        { label: "Düzenli Sipariş",   path: "/subscriptions", icon: <RepeatIcon /> },
        { label: "Teklifler",         path: "/quotes",        icon: <RequestQuoteIcon /> },
        { label: "B2B Fiyatlandırma", path: "/b2b-pricing",   icon: <AttachMoneyIcon /> },
        { label: "İade Talepleri",    path: "/returns",       icon: <AssignmentReturnIcon /> },
      ],
    },
    {
      section: "Katalog",
      items: [
        { label: "Ürünler",            path: "/products",            icon: <InventoryIcon /> },
        { label: "Ürün 360",           path: "/product360",          icon: <ScreenSearchDesktopIcon /> },
        { label: "Kategoriler",        path: "/categories",          icon: <CategoryIcon /> },
        { label: "Stok Yönetimi",      path: "/stock",               icon: <WarningAmberIcon /> },
        { label: "Stok Düzeltme",      path: "/stock-adjustments",   icon: <BuildIcon /> },
        { label: "Toplu Ürün Import",  path: "/bulk-product-import", icon: <UploadFileIcon /> },
        { label: "Tedarikçiler",       path: "/suppliers",           icon: <LocalShippingIcon /> },
      ],
    },
    {
      section: "Müşteri & CRM",
      items: [
        { label: "Müşteriler",         path: "/users",             icon: <PeopleIcon /> },
        { label: "Yeni Onaylar",       path: "/pending",           icon: <NotificationsIcon />, badgeKey: "pending" },
        { label: "Toplu Müşteri Imp.", path: "/bulk-import",       icon: <UploadFileIcon /> },
        { label: "Sessiz Müşteriler",  path: "/silent-customers",  icon: <GroupsIcon /> },
        { label: "RFM Analizi",        path: "/rfm",               icon: <GroupsIcon /> },
        { label: "Cohort / Retention", path: "/cohort",            icon: <GridViewIcon /> },
        { label: "Customer Journey",   path: "/journey",           icon: <RouteIcon /> },
        { label: "Yorumlar",           path: "/reviews",           icon: <RateReviewIcon /> },
        { label: "NPS Skoru",          path: "/nps",               icon: <StarIcon /> },
        { label: "Kuponlar",           path: "/coupons",           icon: <LocalOfferIcon /> },
      ],
    },
    {
      section: "Pazarlama",
      items: [
        { label: "Pazarlama Merkezi",  path: "/marketing",         icon: <RocketLaunchIcon /> },
        { label: "Email Reklam",       path: "/email-campaign",    icon: <EmailIcon /> },
        { label: "Email Performans",   path: "/email-performance", icon: <MarkEmailReadIcon /> },
        { label: "Drip Kampanya",      path: "/drip-builder",      icon: <AccountTreeIcon /> },
        { label: "Push Kampanyalar",   path: "/push-campaigns",    icon: <CampaignIcon /> },
        { label: "Broşür / Kampanya",  path: "/campaigns",         icon: <CampaignIcon /> },
        { label: "WhatsApp",           path: "/whatsapp",          icon: <WhatsAppIcon /> },
        { label: "Sepeti Terk",        path: "/abandoned-cart",    icon: <RemoveShoppingCartIcon /> },
        { label: "Hoş Geldin Serisi",  path: "/welcome-email",     icon: <WavingHandIcon /> },
        { label: "Akıllı Öneriler",    path: "/recommendations",   icon: <LightbulbIcon /> },
        { label: "Cross-Sell",         path: "/cross-sell",        icon: <ConnectingAirportsIcon /> },
      ],
    },
    {
      section: "Analitik",
      items: [
        { label: "Raporlar",         path: "/reports",        icon: <BarChartIcon /> },
        { label: "KDV Beyanname",    path: "/vat-report",     icon: <BarChartIcon /> },
        { label: "🎯 Talep Formları (Leads)", path: "/leads", icon: <BarChartIcon /> },
        { label: "Kar Marjı",        path: "/margin-report",  icon: <BarChartIcon /> },
        { label: "Ürün Rotasyonu",   path: "/rotation-report",icon: <BarChartIcon /> },
        { label: "Pazar Analizi",    path: "/pazar-analizi",  icon: <BarChartIcon /> },
        { label: "Sales Funnel",     path: "/funnel",         icon: <FilterListIcon /> },
        { label: "Sales Pattern",    path: "/sales-pattern",  icon: <CalendarViewWeekIcon /> },
        { label: "Kategori & Marka", path: "/category-sales", icon: <CategoryIcon /> },
        { label: "Forecast",         path: "/forecast",       icon: <QueryStatsIcon /> },
        { label: "Aylık Hedefler",   path: "/monthly-goals",  icon: <EmojiEventsIcon /> },
        { label: "Site Trafiği",     path: "/site-traffic",   icon: <PublicIcon /> },
        { label: "Coğrafi Trafik",   path: "/geo",            icon: <MapIcon /> },
      ],
    },
    {
      section: "Finans",
      items: [
        { label: "Cari Hesap", path: "/cari-hesap", icon: <AccountBalanceIcon /> },
      ],
    },
    {
      section: "Yönetim",
      items: [
        { label: "İçe / Dışa Aktar", path: "/import-export",  icon: <ImportExportIcon /> },
        { label: "Entegrasyonlar",   path: "/integrations",   icon: <SettingsInputComponentIcon /> },
        { label: "Admin Kullanıcılar", path: "/admin-users",  icon: <AdminPanelSettingsIcon /> },
        { label: "Audit Log",        path: "/audit-log",      icon: <HistoryIcon /> },
        { label: "Sistem Sağlığı",   path: "/system-health",  icon: <HealthAndSafetyIcon /> },
        { label: "BH Retry Kuyruğu", path: "/bh-retry-queue", icon: <HistoryIcon /> },
        { label: "Ayarlar",          path: "/settings",       icon: <SettingsIcon /> },
      ],
    },
  ];
}

export function useNavMenu() {
  const userPerms = useMemo(() => getUserPermissions(), []);
  const [pendingCount, setPendingCount] = useState(0);

  useEffect(() => {
    let cancelled = false;
    const load = () => {
      getUsers().then(r => {
        if (cancelled) return;
        const count = (r.data || []).filter(u => u.status === "pending_approval").length;
        setPendingCount(count);
      }).catch(() => {});
    };
    load();
    const interval = setInterval(load, 30000);
    return () => { cancelled = true; clearInterval(interval); };
  }, []);

  const sections = useMemo(() => {
    const definition = buildMenuDefinition();
    return definition
      .map(group => ({
        section: group.section,
        items: group.items.filter(item => canAccessPath(userPerms, item.path)),
      }))
      .filter(group => group.items.length > 0);
  }, [userPerms]);

  const badges = { pending: pendingCount };

  return { sections, badges };
}
